import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { certificateService } from '../services/supabaseClient';
import { certificatePdf } from '../utils/certificate';
import { FiDownload } from 'react-icons/fi';

function formatDate(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export default function PartnerCertificates({ session }) {
  const location = useLocation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      setError('');
      try {
        const data = await certificateService.getForPartner(session.partnerId);
        setRows(data || []);
      } catch (err) {
        setError(err.message || 'Unable to load certificates.');
      } finally {
        setLoading(false);
      }
    };
    if (session?.partnerId) load();
  }, [session?.partnerId]);

  // agar Requests tab se "View Certificate" click karke aaye hain, matching row highlight ho
  const highlightStudentId = location.state?.studentId;
  const highlightCourseId = location.state?.courseId;

  const personName = row =>
    `${row.students?.first_name || ''} ${row.students?.last_name || ''}`.trim();

  const download = async row => {
    // pdf_url already Supabase storage me pada hai, wahi kholte hain
    if (row.pdf_url) {
      window.open(row.pdf_url, '_blank', 'noopener,noreferrer');
      return;
    }
    // fallback: pdf_url na ho to on-the-fly regenerate
    const verifyUrl = `${window.location.origin}/verify/${row.id}`;
    await certificatePdf({
      personName: personName(row),
      contentName: row.course?.name || '',
      certificateId: row.certificate_id || row.id,
      uuid: row.id,
      verifyUrl
    });
  };

  return (
    <div>
      <div className="hero">
        <div>
          <span className="tag">CERTIFICATES</span>
          <h2>Your Certificates</h2>
          <p>Your issued certificates are available here.</p>
        </div>
      </div>

      <div className="panel">
        <div className="panel-head">
          <div>
            <h3>Issued Certificates</h3>
            <p>{rows.length} certificate{rows.length === 1 ? '' : 's'} issued</p>
          </div>
        </div>

        {error && <div className="error">{error}</div>}

        <div className="table-wrap flat">
          <table>
            <thead>
              <tr>
                <th>Certificate ID</th>
                <th>Person</th>
                <th>Email</th>
                <th>Course</th>
                <th>Issue Date</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={6} className="empty-row">Loading...</td></tr>
              )}

              {!loading && rows.length === 0 && (
                <tr><td colSpan={6} className="empty-row">No certificates yet.</td></tr>
              )}

              {!loading && rows.map(row => {
                const isHighlighted =
                  highlightStudentId && highlightCourseId &&
                  row.student_id === highlightStudentId &&
                  row.course_id === highlightCourseId;

                return (
                  <tr key={row.id} className={isHighlighted ? 'row-highlight' : undefined}>
                    <td><b>{row.certificate_id || '—'}</b></td>
                    <td>{personName(row)}</td>
                    <td>{row.students?.email || '—'}</td>
                    <td>{row.course?.name || '—'}</td>
                    <td>{formatDate(row.issue_date)}</td>
                    <td className="actions">
                      <button type="button" onClick={() => download(row)}>
                        <FiDownload size={11} style={{ marginRight: 5, verticalAlign: -1 }} />
                        Download PDF
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}